import React from 'react';
import cls from './StageItem.module.css';
import classNames from 'classnames';
import { usePlanFact } from '../../../hooks/usePlanFact';
import { getFinalWidth } from '../../../helpers/getFinalWidth';
import { useSelector } from 'react-redux';

export const PlanFactStageItem = ({ stage }) => {
    const { activeTab } = useSelector((state) => state.gantReducer);

    const { planWidth, factWidth, factLeft } = usePlanFact(stage, 'stage', activeTab);
    let finalWidth = getFinalWidth(planWidth, activeTab, stage.planned.days_count);
    let finalWidthFact = getFinalWidth(factWidth, activeTab, stage.planned.days_count);

    let isShowSmallMain = true;
    let isShowSmallMainFact = true;

    if (activeTab !== 'day') {
        if (activeTab === 'week' && +stage.planned.days_count < 2) {
            isShowSmallMain = false;
        }
        if (activeTab === 'week' && +stage.actual.days_count < 2) {
            isShowSmallMainFact = false;
        }
        if (activeTab === 'month' && +stage.planned.days_count < 3) {
            isShowSmallMain = false;
        }
        if (activeTab === 'month' && +stage.actual.days_count < 3) {
            isShowSmallMainFact = false;
        }
    }
    return (
        <div className={classNames(cls.wrapper)}>
            <div className={cls.planElementWrapper}>
                <div
                    style={{ width: finalWidth + (isShowSmallMain ? 1 : 0) }}
                    className={classNames(!isShowSmallMain ? cls.smallWrapper : cls.planElement)}
                />
            </div>
            <div
                id={`${stage.id}`}
                style={{ left: factLeft }}
                className={classNames(cls.StageItem, { [cls.planFact]: isPlanFact })}
            >
                {isShowSmallMainFact && (
                    <svg
                        width="12"
                        height="32"
                        viewBox="0 0 12 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0 4.57143C0 2.0467 1.79086 0 4 0H8C10.2091 0 12 2.0467 12 4.57143V27.4286C12 29.9533 10.2091 32 8 32H4C1.79086 32 0 29.9533 0 27.4286V4.57143Z"
                            fill={stage.done_percent > 0 ? ' #1094F7' : '#CBE9FF'}
                        />
                        <path
                            d="M12 6H8V5C8 4.44772 7.55228 4 7 4H5C4.44772 4 4 4.44772 4 5V27C4 27.5523 4.44772 28 5 28H7C7.55228 28 8 27.5523 8 27V26H12V28C12 30.2091 10.2091 32 8 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V6Z"
                            fill="#1094F7"
                        />
                    </svg>
                )}

                {/*<ReactTooltip*/}
                {/*    id={`diagram-stage-${stage.id}`}*/}
                {/*    aria-haspopup="true"*/}
                {/*    effect="solid"*/}
                {/*    delayHide={200}*/}
                {/*    delayShow={200}*/}
                {/*    type="light"*/}
                {/*    className={cls.tooltip}*/}
                {/*>*/}
                {/*    <p>{stage.name}</p>*/}
                {/*</ReactTooltip>*/}
                <div
                    data-tip
                    data-for={`diagram-stage-${stage.id}`}
                    title={stage.name}
                    className={classNames(cls.MainElementProgress, {
                        [cls.backgroundFact]: isPlanFact,
                        [cls.small]: Number(stage.actual.days_count) < 5,
                        [cls.smallElement]: !isShowSmallMainFact,
                        [cls.notRightPadding]:
                            (+stage.planned.days_count < 3 && activeTab !== 'day') ||
                            (factWidth < 22 && activeTab !== 'day'),
                    })}
                    style={{
                        width: finalWidthFact,
                    }}
                >
                    <div className={classNames(cls.textProgress, cls.blackText)}>
                        <div
                            style={{
                                paddingLeft: `${Number(stage.actual.days_count) < 5 ? 0 : 20}px`,
                            }}
                        >
                            {stage?.name}
                        </div>
                    </div>
                    <div
                        className={classNames(cls.progressBar)}
                        style={{ width: `${stage.done_percent}%` }}
                    ></div>
                    <div
                        style={{ width: `${stage.done_percent}%` }}
                        className={classNames(cls.textProgress, cls.whiteText)}
                    >
                        <div
                            style={{
                                paddingLeft: `${Number(stage.actual.days_count) < 5 ? 0 : 20}px`,
                            }}
                        >
                            {stage?.name}
                        </div>
                    </div>
                </div>
                {isShowSmallMainFact && (
                    <svg
                        style={{ marginLeft: '-1px' }}
                        width="12"
                        height="32"
                        viewBox="0 0 12 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 4.57143C12 2.0467 10.2091 0 8 0H4C1.7909 0 0 2.0467 0 4.57143V27.4286C0 29.9533 1.7909 32 4 32H8C10.2091 32 12 29.9533 12 27.4286V4.57143Z"
                            fill={stage.done_percent >= 100 ? ' #1094F7' : '#CBE9FF'}
                        />
                        <path
                            d="M0 6H4V5C4 4.44772 4.44772 4 5 4H7C7.55228 4 8 4.44772 8 5V27C8 27.5523 7.55228 28 7 28H5C4.44772 28 4 27.5523 4 27V26H0V28C0 30.2091 1.79086 32 4 32H6H8C10.2091 32 12 30.2091 12 28V4C12 1.79086 10.2091 0 8 0H4C1.79086 0 0 1.79086 0 4V6Z"
                            fill="#1094F7"
                        />
                    </svg>
                )}
            </div>
        </div>
    );
};
